<page-banner imageUrl="page-banner-1.png" headingText="Forgot password"></page-banner>

<div class="content-container">

  <div class="container forgot-pwd-container">
    <div class="d-flex justify-content-center align-items-center">
      <div class="col-md-6">
        <!-- REQUEST RESET -->
        <div class="card square-edges bg-neutral-50" *ngIf="!resetMode">
          <div class="card-body" *ngIf="!requestSuccess">
            <h3>Reset password</h3>
            <p class="font-sm mb-0">Please enter your username or email to request a password reset.</p>
            <form #thisForm="ngForm" class="mt-3">
              <websilk-text-field id="txtUsername" class="font-sm" name="txtUsername" [(ngModel)]="username" displayInline="false" placeholderText="Username / Email" required="true"></websilk-text-field>
              <div>
                <button type="button" class="btn btn-primary btn-red pl-2 pr-2 w-100" (click)="RequestPasswordReset(thisForm,$event)" *ngIf="!processing">Request Password Reset</button>
                <span class="btn btn-dark" *ngIf="processing"><i class="fa fa-spinner fa-spin"></i> Processing...</span>
              </div>
              <div class="alert alert-danger rounded-0 p-2 font-sm" *ngIf="requestResponse && !requestResponse.Success">
                <i class="fas fa-exclamation-circle text-red font-md p-0 pr-2"></i>
                <span class="text-opacity-7">There was a problem requesting a password reset: <i>{{requestResponse.Message}}</i></span>
              </div>
            </form>
          </div>

          <div class="card-body" *ngIf="requestSuccess">
            <div class="alert alert-success p-2 font-sm rounded-0">
              A password reset request has been sent to the email registered on file. Please check your SPAM if it does not appear in your email within the next 5 minutes.
            </div>
          </div>
        </div>
        <!-- /REQUEST RESET -->
        <!-- REQUEST RESET -->
        <div class="card square-edges bg-neutral-50" *ngIf="resetMode">

          <!-- <div class="card-header bg-dark text-white">Reset Password</div> -->
          <div class="card-body" *ngIf="!requestSuccess || (requestSuccess && requestError)">
            <h3>Reset password</h3>
            <p class="font-sm">Please enter your new password below and confirm.</p>
            <form #thisResetForm="ngForm" class="mt-5">
              <!-- <websilk-text-field id="txtPassword" name="txtPassword" [(ngModel)]="passwordReset.Password" displayInline="false" labelText="Password" required="true" pattern="" fieldType="password"></websilk-text-field>
            <websilk-text-field id="txtConfirmPassword" name="txtConfirmPassword" [(ngModel)]="passwordReset.ConfirmPassword" displayInline="false" labelText="Confirm" required="true" [pattern]="'^'+this.passwordReset.Password+'$'" fieldType="password" errorText="Must match password"></websilk-text-field> -->
              <div class="form-group">
                <label class="control-label font-sm" for="txt_Password">Create password</label>
                <input type="password" id="txt_Password" name="txt_Password" class="form-control form-control-lg input-blue-border" [(ngModel)]="passwordReset.Password" pattern="^.{13,50}$" required>
                <span class="error-label font-sm">Password is required and must be a minimum length of 13 alphanumeric characters</span>
              </div>

              <div class="form-group">
                <label class="control-label font-sm" for="txt_ConfirmPassword">Confirm password</label>
                <input type="password" id="txt_ConfirmPassword" name="txt_ConfirmPassword" class="form-control form-control-lg input-blue-border" [(ngModel)]="passwordReset.ConfirmPassword" required>
                <span class="text-danger font-sm" *ngIf="confirmPasswordError">Confirm password must match password</span>
              </div>

              <div>
                <button type="button" class="btn btn-dark btn-red w-100" (click)="PasswordReset(thisResetForm,$event)" *ngIf="!processing">Reset Password</button>
                <span class="btn btn-dark" *ngIf="processing"><i class="fa fa-spinner fa-spin"></i> Processing...</span>
              </div>
              <div class="alert alert-danger rounded-0 p-2 mt-2 font-sm" *ngIf="requestError">
                <i class="fas fa-exclamation-circle text-red font-md p-0 pr-2"></i>
                <span class="text-opacity-7">There was a problem processing your request. Please contact our offices.</span>
              </div>
            </form>
          </div>

          <div class="card-body" *ngIf="requestSuccess">
            <div class="alert alert-success p-2 font-sm rounded-0" *ngIf="!requestError">
              <p>Your password has been successfully reset.</p>
              <p>
                <a [routerLink]="['/login']">Proceed to Login</a>
              </p>
            </div>
          </div>

        </div>
        <!-- /REQUEST RESET -->
      </div>
    </div>
  </div>

</div>
